import { reflectKeys } from "@/utils/key.reflactor";

export const HTTP_ERROR_CATEGORY = reflectKeys([
  "SERVICE_TEMPORARILY_UNAVAILABLE",
  "RATE_LIMIT_REACHED",
  "ACCESS_CONFIGURATION_ISSUE",
  "INVALID_REQUEST",
  "REQUEST_TIMEOUT",
  "INVALID_RESPONSE",
]);

export type HttpErrorCategory = (typeof HTTP_ERROR_CATEGORY)[keyof typeof HTTP_ERROR_CATEGORY];
